module.exports = __webpack_public_path__ + "img/game2.474d8e2c.png";